import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { IngredientsServices } from "../../../services";
import { ConfigurationServices } from '../../../../configuration/services';
import { AddonsTriggerVersionProPage } from '../../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the IngredientPartialIndicatorsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ingredient-partial-indicators',
    templateUrl: 'ingredient-partial-indicators.html',
})
export class IngredientPartialIndicatorsPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public ingredientServices: IngredientsServices,
        public configurationServices: ConfigurationServices) {
    }

    checkState(allergen_uid) {
        var index = this.ingredientServices.ingredient_allergens_tmp.indexOf(allergen_uid, 0);
        if (index > -1) {
            return true
        } else {
            return false
        }
    }

    insert(allergen_uid) {
        if (this.globals.checkLimitsByLicense('stock', 'indicators')) {
            this.ingredientServices.ingredient_allergens_tmp.push(allergen_uid);
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    delete(allergen_uid) {
        var index = this.ingredientServices.ingredient_allergens_tmp.indexOf(allergen_uid, 0);
        if (index > -1) {
            this.ingredientServices.ingredient_allergens_tmp.splice(index, 1);
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-create/ingredient-create-allergens/ingredient-partial-indicators/ingredient-partial-indicators.ts